import { MfsStatusCode } from '../mfsStatusCodes';
import { BEGIN_LOGGING_TEXT, capitalize, END_LOGGING_TEXT, isPromise } from './decoratorUtils';
/** Gets a logVerbose method decorator associated with the given `logger`. */
export function getLogVerboseDecorator(logger) {
    /**
     * Log a warning.
     *
     * @param eventName Name of the event for the activity.
     * @param operationName Name of the operation in the activity.
     * @param mfsStatusCode Status code result of the activity.
     * @param errorInfo Error information of the warning.
     * @param logParams Parameters to log to console.
     */
    function logWarn(eventName, operationName, mfsStatusCode, errorInfo, logParams) {
        logger.logWarn(`${capitalize(eventName)}`, mfsStatusCode, errorInfo, operationName, logParams);
    }
    return function () {
        /** A single decorator that works for both sync & async functions */
        return function logVerbose(_target, methodName, descriptor) {
            const activityName = methodName;
            const originalMethod = descriptor.value;
            descriptor.value = function (...args) {
                logger.logVerbose(methodName, BEGIN_LOGGING_TEXT);
                let isSyncMethod = true;
                try {
                    const result = originalMethod.apply(this, args);
                    // check if function was async
                    if (isPromise(result)) {
                        isSyncMethod = false;
                        // attach then and catch handlers to end the activity correctly
                        return result
                            .then((innerResult) => {
                            return innerResult;
                        })
                            .finally(() => {
                            logger.logVerbose(methodName, END_LOGGING_TEXT);
                        });
                    }
                    // sync function, just return the result and warn if failure
                    if (result && result.error) {
                        logWarn(activityName, methodName, MfsStatusCode.ExpectationFailed, {
                            message: 'Failure in log verbose result',
                            error: result.error,
                        });
                    }
                    return result;
                }
                finally {
                    if (isSyncMethod) {
                        logger.logVerbose(methodName, END_LOGGING_TEXT);
                    }
                }
            };
            return descriptor;
        };
    };
}
//# sourceMappingURL=logVerbose.js.map